'use strict';

var util = require('org/util');

/**
 * @function Blog related functions
 */
exports.init = function () {  

    $('.article-list-item').slice(0, 9).show();
    if ($('.article-list-item').length > 9) {
        $('#more-posts-link').show();
    }

    var openMorePosts = function () {
        $('.article-list-item:hidden').slice(0, 9).show();
        if ($('.article-list-item:hidden').length == 0) {
            $('#load').fadeOut('slow');
            $('#more-posts-link').hide();
        }
    };

    $('#more-posts-link').on('keypress', function (e) {
        e.preventDefault();
        if (e.key === 'Enter' || e.which == 32) {
            openMorePosts();
        }
    });

    $('#more-posts-link').on('click', function (e) {
        e.preventDefault();
        openMorePosts();
    });

    $('.blog-current-folder').on('click', function (e) {
        if (util.isMobileSize()) {
            e.preventDefault();
            $('.blog-navigation').toggleClass('active');
        }
    })
}
